import { useLocation, useNavigate } from 'react-router-dom';
import type { ProjectDto } from '@shared/api/contracts';
import { ProjectForm } from '@widgets/projects/project-form';

interface ProjectsAddLocationState {
  project?: ProjectDto;
}

export function ProjectsAddPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as ProjectsAddLocationState | null;
  const project = state?.project;

  const handleSuccess = () => {
    navigate('/projects');
  };

  return <ProjectForm project={project} onSuccess={handleSuccess} />;
}
